var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.item.course)?_c('a',{staticClass:"course-info-main course-hover"},[_vm._v(_vm._s(_vm.city)+" "+_vm._s(_vm.item.course.date || ''))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }